export default [
    {
        author: 'Volpe',
        body: '<div><!--block--><strong>Jagoda Marinic&nbsp;<br></strong><br><strong>OPINION <br><br>BERLIN </strong>Germany is a peculiar country when it comes to good news about itself, too self-conscious and self-serious to accept anyone’s attempt to see it in a positive light. Every time a foreign newspaper writes about a German scientific achievement or the river surfers of Munich or the hipsters of Berlin, you can hear a low, collective moan: “We’re not cool,” it says. “We’re tragic!”&nbsp;<br><br></div><div><!--block-->For years, the fear has been that anyone who tries to move beyond the country’s dark past is opening the door to a resurgence of far-right nationalism. But there are younger generations now, people who are fed up with German angst and pessimism and in utter need of 21st-century political leadership and debate.<br><br>Standing in their way are the baby boomers, those born during the postwar German economic miracle, who see themselves as the guardians of German memory. One of them, Chancellor Angela Merkel, recently announced the beginning of her withdrawal from German politics. In line to replace her are Annegret Kramp-Karrenbauer, 56, and Friedrich Merz, 63, roughly her same age and outlook. And while a younger generation of politicians is rising — including another potential Merkel successor, Jens Spahn, just 38 — the boomers still hold tight to the levers of power.<br><br>Though boomers like Ms. Merkel present themselves as a bulwark against nationalism, their insistence on a particular kind of German identity is preventing the country from moving forward. In the current government there is not a single politician representing the nation’s diversity, though&nbsp;Ms. Merkel often pays lip service to social unity. Even eastern Germans&nbsp;were represented in the government only after their complete absence was&nbsp;criticized.</div>',
        by_line: 'A test by Volpe',
        end_page: 1,
        id: '1',
        image_caption: 'A test image caption',
        image_name: 'Test 1',
        image_url:
            'https://images.unsplash.com/photo-1549925301-6a10639fdc0c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
        location_in_start_page: { x: '25.8823529411764703', y: '15.02654867256637' },
        start_page: 1,
        title: 'Prueba add-on de punto 1',
        type: 'article',
    },
    {
        author: 'Volpe',
        body: '<div><!--block--><strong>Jagoda Marinic&nbsp;<br></strong><br><strong>OPINION <br><br>BERLIN </strong>Germany is a peculiar country when it comes to good news about itself, too self-conscious and self-serious to accept anyone’s attempt to see it in a positive light. Every time a foreign newspaper writes about a German scientific achievement or the river surfers of Munich or the hipsters of Berlin, you can hear a low, collective moan: “We’re not cool,” it says. “We’re tragic!”&nbsp;<br><br></div><div><!--block-->For years, the fear has been that anyone who tries to move beyond the country’s dark past is opening the door to a resurgence of far-right nationalism. But there are younger generations now, people who are fed up with German angst and pessimism and in utter need of 21st-century political leadership and debate.<br><br>Standing in their way are the baby boomers, those born during the postwar German economic miracle, who see themselves as the guardians of German memory. One of them, Chancellor Angela Merkel, recently announced the beginning of her withdrawal from German politics. In line to replace her are Annegret Kramp-Karrenbauer, 56, and Friedrich Merz, 63, roughly her same age and outlook. And while a younger generation of politicians is rising — including another potential Merkel successor, Jens Spahn, just 38 — the boomers still hold tight to the levers of power.<br><br>Though boomers like Ms. Merkel present themselves as a bulwark against nationalism, their insistence on a particular kind of German identity is preventing the country from moving forward. In the current government there is not a single politician representing the nation’s diversity, though&nbsp;Ms. Merkel often pays lip service to social unity. Even eastern Germans&nbsp;were represented in the government only after their complete absence was&nbsp;criticized.</div>',
        by_line: 'A test by Volpe',
        end_page: 1,
        id: '2',
        image_caption: 'A test image caption',
        image_name: 'Test 2',
        image_url:
            'https://images.unsplash.com/photo-1549932967-c60dce5958ce?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
        location_in_start_page: { x: '41.8823529411764703', y: '72.02654867256637' },
        start_page: 1,
        title: 'Prueba add-on de punto 2',
        type: 'image',
    },
    {
        author: 'Volpe',
        body: '<div><!--block--><p>Anchored to the whole page: the reader reaches it through the page badge, not a point marker.</p></div>',
        by_line: 'A test by Volpe',
        end_page: 1,
        id: '3',
        image_caption: null,
        image_name: null,
        image_url: null,
        location_in_start_page: null,
        start_page: 1,
        title: 'Prueba add-on de página 1',
        type: 'article',
    },
    {
        author: 'Volpe',
        body: '<div><!--block--><p>A second page-anchored piece on the same page, so the badge has a list to show.</p></div>',
        by_line: 'A test by Volpe',
        end_page: 1,
        id: '4',
        image_caption: null,
        image_name: null,
        image_url: null,
        location_in_start_page: null,
        start_page: 1,
        title: 'Prueba add-on de página 2',
        type: 'video',
    },
    {
        anchor: {
            type: 'text',
            page: 1,
            selection: {
                type: 'pdf',
                startPage: 1,
                startPageStartOffset: 14,
                startPageLength: 16,
                endPage: 1,
                endPageLength: 16,
            },
        },
        author: 'Volpe',
        body: "<div><!--block--><p>Anchored to the date line at the top-left of page 1: the marker docks at the text column's edge, level with that line.</p></div>",
        by_line: 'A test by Volpe',
        end_page: 1,
        id: '5',
        image_caption: null,
        image_name: null,
        image_url: null,
        location_in_start_page: null,
        start_page: 1,
        title: 'Prueba add-on de texto',
        type: 'link',
    },
    {
        author: 'Volpe',
        body: '<div><!--block--><p>A draft: editors see it with the Draft pill, readers never do.</p></div>',
        by_line: 'A test by Volpe',
        end_page: 1,
        id: '6',
        image_caption: null,
        image_name: null,
        image_url: null,
        location_in_start_page: null,
        start_page: 1,
        status: 'draft',
        title: 'Prueba add-on borrador',
        type: 'article',
    },
];
